module.exports = __webpack_public_path__ + "static/media/highmark.091d1786.png";